import DesignTokens from '@tableau/design-tokens';
import { CSSProperties } from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

const vizViewerRevisionPreviewInfoBarHeight = '50px';
const vizviewerBreadcrumbsHeight = '0px';
const stylePrefix = 'viz-viewer';

export const infoBarContentStyle = cssClass(stylePrefix, 'info-bar-content', {
  lineHeight: vizViewerRevisionPreviewInfoBarHeight
});

export const infoBarStyle = cssClass(stylePrefix, 'info-bar', {
  backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.White),
  height: vizViewerRevisionPreviewInfoBarHeight
});

const positionVizBelowInfoBarStyle: CSSProperties = {
  top: vizViewerRevisionPreviewInfoBarHeight,
  right: 0,
  bottom: '1px',
  left: 0,
};

const positionVizBelowBreadbrumbBarStyle: CSSProperties = {
  top: vizviewerBreadcrumbsHeight,
  right: 0,
  bottom: '1px',
  left: 0,
};

const scrollStyle: CSSProperties = {
  overflowX: 'auto',
  overflowY: 'auto',
  outlineColor: 'initial',
  outlineStyle: 'initial',
  outlineWidth: '1px',
};

const vizContainerStyle: CSSProperties = {
  position: 'absolute',
  borderBottomWidth: '1px', // The 1px bottom and border-bottom are to work around an iPad scrolling bug.  See TFSID:438709.
  borderBottomStyle: 'solid',
};

export const vizContainerStyleClass = cssClass(stylePrefix, 'viz-container', {
  $nest: {
    '@media screen': {
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.Grey245),
      borderBottomColor: applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.Grey245),
    },
    '@media print': {
      backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.White),
      borderBottomColor: applyColor(DesignTokens.color.elevation.border.inverse.dark, CommonStyles.Colors.White),
    }
  }
});

export const vizWithInfoBarStyle: CSSProperties =  {
  ...vizContainerStyle,
  ...positionVizBelowInfoBarStyle,
  ...scrollStyle
};

export const vizWithBreadcrumbStyle: CSSProperties = {
  ...vizContainerStyle,
  ...positionVizBelowBreadbrumbBarStyle,
  ...scrollStyle
};

export const fillViewPort: CSSProperties = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};

export const vizSpaceVizStyle: CSSProperties = {
  height: '100%',
  width: '100%'
};

export const vizStyle: CSSProperties = {
  ...vizSpaceVizStyle,
  backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.White)
};

export const vizClass = cssClass(stylePrefix, 'viz', {
  $nest: {
    'iframe': {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }
});
